



















































import { Component, Prop, Vue } from "vue-property-decorator";


import firebase from "firebase/app";
import { LoginState } from "@/store/modules/user";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";

const notExist = (value, vm) => {
    if (vm.submitError) {
        // clear error after 1st display
        const error = vm.submitError;
        vm.submitErrorMessage = error;
        vm.submitError = false;
        return false;
    }
    return true;
};

const emailValidator = helpers.regex(
    "emailValidator",
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
);

@Component({
    components: {},
    mixins: [validationMixin],
    validations: {
        email: {
            required,
            emailValidator,
            notExist,
        },
    },
})
export default class PasswordSearch extends Vue {
    private email: string = "";
    private show: boolean = false;

    async sendEmail(event) {
        //todo: 존재하는 이메일인지 아닌지확인

        event.preventDefault();
        this.$v.email.$touch();
        // if (this.$v.email.$anyError) {
        //     return;
        // }
        try {
            const result = await firebase
                .auth()
                .sendPasswordResetEmail(this.email);
            this.$modal.show('checkMailModal')
        } catch {
            // this.submitError = true;
        }
    }

    closeModal() {
        this.$modal.hide('checkMailModal')
        this.$router.push(`/${this.i18n.locale}/login`)
    }

}
